import { elevate } from '@/styles/grommet-theme';
import theme from '@/styles/theme';

export const useCombinedTheme = () => ({ ...theme, ...elevate });
